<footer class="fm-footer fm-light-bg">
  <div class="container-xl">
    <div class="fm-footer-top">
      <div class="row g-4">
        <div class="col-lg-4">
          <a routerLink="/">
            <img src="images/logo.svg" alt="Forever Memories" width="180" />
          </a>
          <p class="mt-3 mb-0">
            Capture the wisdom, love, and legacy of your life through video, audio, and photos.
          </p>
        </div>
        <div class="col-sm-4 col-lg-2 offset-lg-2">
          <h6 class="fm-head-sty2 fw-bold mb-3">Product</h6>
          <ul class="list-unstyled">
            <li><a href="#fmFeatures" class="fm-footer-link">Features</a></li>
            <li><a href="#fmHowItWorks" class="fm-footer-link">How it Works</a></li>
            <li><a href="#fmStories" class="fm-footer-link">Stories</a></li>
          </ul>
        </div>
        <div class="col-sm-4 col-lg-2">
          <h6 class="fm-head-sty2 fw-bold mb-3">Account</h6>
          <ul class="list-unstyled">
            <li><a routerLink="/register" class="fm-footer-link">Sign Up</a></li>
            <li><a routerLink="/login" class="fm-footer-link">Sign In</a></li>
          </ul>
        </div>
        <div class="col-sm-4 col-lg-2">
          <h6 class="fm-head-sty2 fw-bold mb-3">Legal</h6>
          <ul class="list-unstyled">
            <li><a href="javascript:void(0);" class="fm-footer-link">Privacy Policy</a></li>
            <li><a href="javascript:void(0);" class="fm-footer-link">Terms of Service</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="fm-footer-bottom">
      <p class="mb-0 text-center">&copy; {{ currentYear }} Forever Memories. All rights reserved.</p>
    </div>
  </div>
</footer>
